// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m8RSUrcrjtREQ78fG9Ec {
  cursor: pointer;
}
.m8RSUrcrjtREQ78fG9Ec .anticon {
  display: none;
}
.m8RSUrcrjtREQ78fG9Ec:hover .anticon {
  display: initial;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Project/Assets/Files/DirectoryName/index.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAFA;EAIM,aAAA;AACN;AAGE;EAGM,gBAAA;AAHR","sourcesContent":[".container {\n  cursor: pointer;\n  :global {\n    .anticon {\n      display: none;\n    }\n  }\n\n  &:hover {\n    :global {\n      .anticon {\n        display: initial;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `m8RSUrcrjtREQ78fG9Ec`
};
export default ___CSS_LOADER_EXPORT___;
